import { useParams } from 'wouter';
import { useState } from 'react';
import { AdminProjects } from '@platform/client';
import ProjectPublishStageModal from './ProjectPublishStageModal';
import FlexibleLink from '../../../util/FlexibleLink';
import {
  ReviewPageWrapper,
  ReviewItem,
  ReviewItemShort,
  ReviewPageIconItem,
  AdminViewPageAction,
} from '../../AdminViewPage';
import { getProjectBadgeColor } from './ProjectsAdmin';
import ProjectRecommendationModal from './ProjectRecommendationModal';
import { ADMIN_ROUTES, ROUTES } from '../../../routes/consts';

export const ProjectReview = () => {
  const { projectId } = useParams();
  const [publishStageModalIsOpen, setPublishStageModalIsOpen] = useState(false);
  const [recommendProjectModalIsOpen, setRecommendProjectModalIsOpen] = useState(false);
  const {
    data: project,
    isError,
    isLoading,
    isSuccess,
  } = AdminProjects.useGetReviewProject(Number(projectId));

  if (!project) {
    return null;
  }

  const headerIconItems: ReviewPageIconItem[] = [
    { icon: 'globe-01', label: 'Timezone', value: project.timezone },
    { icon: 'user-01', label: 'Role Type', value: project.roleType },
  ];
  if (project.openToTeam) {
    headerIconItems.push({ icon: 'users-02', label: 'Open to Teams', value: 'Open to Teams' });
  }

  const pageActions: AdminViewPageAction[] = [
    {
      type: 'link',
      text: 'Edit',
      href: `/platform/admin/projects/edit${projectId}`,
    },
    {
      type: 'button',
      text: 'Update publish stage',
      onPress: () => setPublishStageModalIsOpen(true),
    },
  ];
  if (project.publishingStage === 'published') {
    pageActions.push({
      type: 'button',
      text: 'Recommend',
      onPress: () => setRecommendProjectModalIsOpen(true),
    });
  }

  return (
    <ReviewPageWrapper
      title={project.name}
      backNavigation={{
        label: 'Back to projects',
        href: `~/platform${ROUTES.ADMIN}${ADMIN_ROUTES.PROJECTS}`,
      }}
      headerIconItems={headerIconItems}
      pageActions={pageActions}
      badge={{
        text: project.publishingStage,
        color: getProjectBadgeColor(project.publishingStage, project.publishingStageDate),
      }}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
    >
      <ReviewItemShort
        label='Organization'
        value={
          <FlexibleLink
            type='legacy'
            href={`/organization/${project.organizationId}`}
            className='text-brand-500 hover:underline'
            newTab={true}
          >
            {project.organizationName}
          </FlexibleLink>
        }
      ></ReviewItemShort>
      <ReviewItemShort label='Skills' value={project.expertises} />
      <ReviewItemShort label='Language(s)' value={project.language} />
      <ReviewItemShort label='Business Challenge' value={project.businessType} />
      <ReviewItem label='Description'>
        <p
          dangerouslySetInnerHTML={{
            __html: project.description ? project.description : 'Not Provided',
          }}
        ></p>
      </ReviewItem>
      <ReviewItem label='Goals'>
        <p
          dangerouslySetInnerHTML={{
            __html: project.goals ? project.goals : 'Not Provided',
          }}
        ></p>
      </ReviewItem>
      <ReviewItem label='Other Requirements'>
        <p
          dangerouslySetInnerHTML={{
            __html: project.otherRequirements ? project.otherRequirements : 'Not Provided',
          }}
        ></p>
      </ReviewItem>
      <ReviewItem label='Benefits'>{project.benefits}</ReviewItem>
      <ReviewItem label='Learning Outcomes'>
        <p
          dangerouslySetInnerHTML={{
            __html: project.learningOutcomes ? project.learningOutcomes : 'Not Provided',
          }}
        ></p>
      </ReviewItem>
      <ProjectPublishStageModal
        isOpen={publishStageModalIsOpen}
        project={project}
        onClose={() => {
          setPublishStageModalIsOpen(false);
        }}
      />
      {recommendProjectModalIsOpen && (
        <ProjectRecommendationModal
          projectId={project.id}
          onClose={() => setRecommendProjectModalIsOpen(false)}
        />
      )}
    </ReviewPageWrapper>
  );
};
